import { refreshCartFragments, isBtnLocked } from "../../utils/cart-fragments";
import celebrate from "../../utils/celebrate";

// .js-add-grouped-to-cart (data-product_id) : les "collections" poussées
// via modal-collection-push sont des produits WooCommerce "grouped", donc
// pas ajoutables au panier directement (voir GroupedCart.php côté serveur,
// qui ajoute chacun des enfants).
export default function initCartAddGrouped() {
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-add-grouped-to-cart');
        if (!btn) return;

        e.preventDefault();
        if (isBtnLocked(btn)) return;
        btn.classList.add('loading');
        celebrate(btn);

        var body = new FormData();
        body.append('action', 'add_grouped_to_cart');
        body.append('product_id', btn.dataset.product_id);

        var ajaxUrl = (window.vsAssets && window.vsAssets.ajaxUrl) || '/wp/wp-admin/admin-ajax.php';

        fetch(ajaxUrl, { method: 'POST', body: body })
            .then(function (r) {
                return r.json();
            })
            .then(function (data) {
                if (!data || !data.success) return;

                return refreshCartFragments().then(function () {
                    if (window.jQuery) {
                        window.jQuery(document.body).trigger('added_to_cart');
                    }
                });
            })
            .finally(function () {
                btn.classList.remove('loading');
            });
    });
}
